const Colours = {
  Grey: '#00000099',
  LightGrey: '#00000061',
  LighterGrey: '#F5F5F5',
  DarkGrey: '#444444',
};

export const KanbanCardStyles = {
  accordionDetails: {
    padding: 0,
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },

  container: {
    color: Colours.Grey,
    py: 1,
    px: 2,
    my: 5,
    borderRadius: '8px',
    '& > *': {
      my: '3%',
    },
  },
  assigneeContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    mb: '5%',
  },

  avatar: {
    width: '20px',
    height: '20px',
  },

  accordion: {
    color: Colours.Grey,
    '& .MuiAccordionSummary-root': {
      padding: 0,
      margin: 0,
    },
  },
  accordionSummaryIconBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    mb: 2,
  },

  zoneName: {
    cursor: 'pointer',
    color: Colours.DarkGrey,
  },
};

export const KanbanColumnStyles = {
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    mb: '5%',
    color: Colours.DarkGrey,
  },
  zoneCount: {
    backgroundColor: Colours.LighterGrey,
    color: Colours.DarkGrey,
    borderRadius: '8px',
    p: 1,
    fontWeight: 600,
  },
};

export const KanbanViewerStyles = {
  rootContainer: {
    width: '100%',
    mt: '2%',
  },
  tabsContainer: { borderBottom: 1, borderColor: 'divider', display: 'flex' },
  searchField: {
    ml: 'auto',
    border: 'none',
    '& fieldset': { border: 'none' },
  },
};
